(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('bopi-sticky-bar');
    if (!bar) return;

    var threshold = parseInt(bar.getAttribute('data-show-after'), 10) || 500;
    var ticking = false;

    function update() {
      var visible = window.scrollY > threshold;
      bar.classList.toggle('is-visible', visible);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update(); // set correct initial state (e.g. on page reload mid-scroll)
  });
})();
